import PaginatedResponse from "_shared/_api/pagination/responses/paginated-response";
import type { PermissionTemplatesPage } from "permissions/_api/permission-templates-api-service";
import PermissionTemplate from "permissions/templates/permission-template";

export type PermissionTemplatesResult = PaginatedResponse<PermissionTemplate> & {
  errorCount: number;
};

export function toPermissionTemplatesResult(
  page: PermissionTemplatesPage | undefined,
): PermissionTemplatesResult | undefined {
  if (!page) return undefined;

  return Object.assign(PaginatedResponse.from(PermissionTemplate.fromJSONArray(page.data), page.headers), {
    errorCount: page.errorCount,
  });
}
